import ABBREV_TO_STATE from './abbrev-to-state.json';
import AM4CHARTS_ABBREV from './am4charts-abrev.json';
import getStateMap from './state-map-obj';

const AM4CHARTS_ABBREV_CAPITALIZED = Object.entries(AM4CHARTS_ABBREV).reduce((acc, [key, value]) => ({ ...acc, [key.toUpperCase()]: value }), {});
const STATE_TO_ABBREV = Object.entries(ABBREV_TO_STATE).reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
const ABBREV_TO_STATE_TITLECASE = Object.entries(ABBREV_TO_STATE).reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

const AUTH_TOKEN_KEY = 'MYBALLOT_USER_TOKEN';
const AUTH_USER_ID = 'MYBALLOT_USER_ID';

const NATL_TOPICS = ['gun control', 'immigration', 'crime', 'climate crisis'];

const SERVER_ENDPOINTS = {
  LOCAL: 'http://localhost:9090',
  PROD: 'https://my-ballot-backend.herokuapp.com',
};

const getServerUrl = () => {
  switch (window.location.origin) {
    case 'http://localhost:8080':
      return SERVER_ENDPOINTS.PROD; // could to LOCAL if running server locally

    case 'https://my-ballot.netlify.app':
      return SERVER_ENDPOINTS.PROD;

    default:
      return SERVER_ENDPOINTS.PROD;
  }
};

export {
  ABBREV_TO_STATE,
  ABBREV_TO_STATE_TITLECASE,
  AM4CHARTS_ABBREV_CAPITALIZED,
  AM4CHARTS_ABBREV,
  AUTH_TOKEN_KEY,
  AUTH_USER_ID,
  getServerUrl,
  getStateMap,
  NATL_TOPICS,
  SERVER_ENDPOINTS,
  STATE_TO_ABBREV,
};
